module.exports = __webpack_public_path__ + "180caaf40628404de4f825b1d787f56c.svg";